import { ToastController } from 'ionic-angular';

export class ToastHelper {

    constructor() { }

    public static Show(toastCtrl: ToastController, message: string, duration: number = 3000) {
        toastCtrl
            .create({
                message: message,
                duration: duration,
                position: 'top',
            })
            .present();
    }
}


// WEBPACK FOOTER //
// ./src/helpers/toastr-helper.ts